"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chevron_small_down = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const chevron_small_down = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'chevron-small-down-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.46967 8.08869C5.76256 7.7958 6.23744 7.7958 6.53033 8.08869L10 11.5584L13.4697 8.08869C13.7626 7.7958 14.2374 7.7958 14.5303 8.08869C14.8232 8.38158 14.8232 8.85646 14.5303 9.14935L10.5303 13.1493C10.3897 13.29 10.1989 13.369 10 13.369C9.80109 13.369 9.61032 13.29 9.46967 13.1493L5.46967 9.14935C5.17678 8.85646 5.17678 8.38158 5.46967 8.08869Z', fill: '#4B5563' })));
};
exports.chevron_small_down = chevron_small_down;
